import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { ColorCodeGeneretor } from "./../../../CommanApiFunction";
import dayjs from "dayjs";
import APICall from "../../../../components/Api/APICall";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}
const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: `${dayjs().format("MMMM")} month sale`,
    },
  },
};

let labels = [...Array(daysInMonth(11, 2022) + 1).keys()];
labels.splice(0, 1);

const colorCode = labels.map((v) => ColorCodeGeneretor());

export default function MonthBarGrapghComponent() {
  const [DataSetList, setDataSetList] = useState([]);

  const data = {
    labels,
    datasets: [
      {
        label: "Amount",
        data: DataSetList.map((v) => v.amount),
        backgroundColor: colorCode,
      },
    ],
  };

  useEffect(() => {
    APICall("/service/monthsale").then((responce) => {
      if (responce.status) {
        setDataSetList(responce.message);
      }
    });
  }, []);

  return (
    <Bar options={options}  data={data} className="w-full h-24 md:h-20 lg:h-20"/>
  );
}
